import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPatientAppointment } from "src/components/pages/staff/patients/dep/AccountPatientAppointments";

export interface IAddClinicalNoteDrawerState {
    show: boolean;
    onCloseDrawer?: () => void;
    appointment?: IPatientAppointment;
    accountPatientId?: number;
    staffOnlyFormTemplateIds?: number[];
}

export const initialStateAddClinicalNoteDrawer: IAddClinicalNoteDrawerState = {
    show: false,
    onCloseDrawer: undefined,
    appointment: undefined,
    accountPatientId: undefined,
    staffOnlyFormTemplateIds: undefined,
};

const addClinicalNoteDrawerSlice = createSlice({
    name: "addClinicalNoteDrawer",
    initialState: initialStateAddClinicalNoteDrawer,
    reducers: {
        showAddClinicalNoteDrawer: (
            _state,
            action: PayloadAction<Omit<IAddClinicalNoteDrawerState, "show">>,
        ) => {
            return {
                ...action.payload,
                show: true,
            };
        },
        hideAddClinicalNoteDrawer: (_state) => {
            return initialStateAddClinicalNoteDrawer;
        },
    },
});

export const { showAddClinicalNoteDrawer, hideAddClinicalNoteDrawer } =
    addClinicalNoteDrawerSlice.actions;
export default addClinicalNoteDrawerSlice.reducer;
